module.exports = __webpack_public_path__ + "img/vertical_4_3_8017.ded4acfb.png";